import { computed as o, openBlock as i, createElementBlock as p, normalizeStyle as c } from "vue";
/* empty css                    */
/* empty css                    */
import l from "./design-system.es128.js";
const m = {
  name: "DsSpinner",
  props: {
    /**
     * Number value to set the width and height of the spinner
     */
    size: Number,
    /**
     * Number value to set the border width of the spinner
     */
    thickness: Number
  },
  setup(t) {
    return {
      styles: o(() => {
        const { size: n, thickness: e } = t, s = {};
        return n && (s["--spinner-size"] = `${n}px`), e && (s["--spinner-thickness"] = `${e}px`), s;
      })
    };
  }
};
function a(t, r, n, e, s, d) {
  return i(), p("div", {
    class: "spinner ds-spinner",
    style: c(e.styles)
  }, null, 4);
}
const x = /* @__PURE__ */ l(m, [["render", a], ["__scopeId", "data-v-2cf9d6d2"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es95.js.map
